import { Icon } from "@iconify/react";
import { useAnimation, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import PageFrames from "../ui/pageframes";
import { toast } from "react-toastify";

const Contacts = () => {
  const [showCopied, setShowCopied] = useState(false);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();

  const onCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast.info("Copied!");
  };

  useEffect(() => {
    if (isInView) {
      mainControls.start("visible");
    }
  }, [isInView]);

  useEffect(() => {
    if (showCopied) {
      setTimeout(() => {
        setShowCopied(false);
      }, 3000);
    }
  }, [showCopied]);
  return (
    <PageFrames id="contacts">
      <div className="flex flex-col px-4 gap-2 items-center">
        <div className="flex flex-col md:flex-row items-center md:gap-4 text-[31px] text-center">
          <Icon icon="mdi:contact-outline" className="text-[#002F6C]" />
          <h1>Contact us</h1>
        </div>
        <p className="accent-text text-center">
          Get in touch with us for consultations, product inquiries, service
          support, or career opportunities.
        </p>
      </div>

      <div className="flex w-full px-4 justify-center">
        <div className="flex flex-col w-full lg:max-w-[90%] rounded-lg shadow-lg p-4 bg-[#F2F2F2] gap-8">
          {/* Google Maps Embed */}
          <div className="flex">
            <iframe
              title="location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.3528445996244!2d110.3662773!3d1.5529722000000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31fba7b806adc825%3A0x8ac27bf23b8485d8!2sJK%20Millennium%20Computer%20Centre!5e0!3m2!1sen!2smy!4v1744895613791!5m2!1sen!2smy"
              className="w-full h-64 rounded-md"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Contact Info */}
          <div className="flex flex-col justify-center space-y-4">
            <div>
              <div className="flex items-center gap-2 text-[#002F6C]">
                <Icon icon="mdi:address-marker-outline" />
                <h2 className="text-lg font-semibold">Address</h2>
              </div>
              <p className="text-gray-700">
                Ground Floor, Lot 549, Section62,
                <br />
                Jalan Ang Cheng Ho,
                <br />
                93450 Kuching, Sarawak.
              </p>
            </div>
            <div>
              <div className="flex items-center gap-2 text-[#002F6C]">
                <Icon icon="fluent:call-16-regular" />
                <h2 className="text-lg font-semibold">Phone</h2>
              </div>
              <p
                className="text-gray-700 cursor-pointer hover:text-red-500 active:text-red-800 w-fit font-bold"
                onClick={() => {
                  onCopy("+6082-238554");
                }}
              >
                +6082-238554
              </p>
              <p
                className="text-gray-700 cursor-pointer hover:text-red-500 active:text-red-800 w-fit font-bold"
                onClick={() => {
                  onCopy("+6016-8865172");
                }}
              >
                +6016-8865172
              </p>
            </div>
            <div className="relative">
              <div className="flex items-center gap-2 text-[#002F6C]">
                <Icon icon="bytesize:mail" />
                <h2 className="text-lg font-semibold">Email</h2>
              </div>
              <p
                className="text-gray-700 cursor-pointer hover:text-red-500 active:text-red-800 w-fit font-bold"
                onClick={() => {
                  onCopy("sales@jkmcc.com.my");
                }}
              >
                sales@jkmcc.com.my
              </p>
            </div>
          </div>
        </div>
      </div>
    </PageFrames>
  );
};

export default Contacts;
